export const mainTheme = {
  fontFamily: "'Poppins', 'sans-serif'",
  pallette: {
    main: "red",
    black: {
      main: "#000000",
    },
    silver: {
      main: "#F0F2F8",
      light: "#4D536B",
      primary: "#6B7496",
      secondary: "#C6CBE2",
      dark: "#D8DCEB",
      text: "#667085",
      disabled: "#BED1D5",
      disabledText: "#707998",
      disabledBg: "#0000000a",
    },
    dark: {
      main: "#101828",
    },
    blue: {
      main: "#0A1338",
      primary: "#182353",
      light: "#40a9ff",
      secondary: "#3B5998",
      link: "#00AEEF",
      border: "#1877F2",
      top: "#C5FFFD",
    },
    white: {
      main: "#FFFFFF",
      primary: "#fafafa",
      light: "#f1fcff",
    },
    green: {
      main: "#00A560",
      primary: "#77B747",
      light: "#47FE75",
      secondary: "#18a43b",
      disabled: "#C9FFD6",
      chip: "#cdffcd",
      circle: "#007f00",
      dark: "#148757",
      tooltip: "#37b850",
      free: "#d0feda",
    },
    red: {
      main: "#EF4444",
      primary: "#EF4444",
      secondary: "#E22C2A",
      error: "#7F1D1D",
      light: "#fca5a5",
      border: "#ff4d4f",
      danger: "#ff775d",
      background: "#ffffff",
    },
    orange: {
      main: "#ff6347",
    },
    violet: {
      light: "#E9D7FE",
      main: "#6941C6",
    },
    yellow: {
      main: "#a17c0b",
      secondary: "#FDF7E7",
      light: "#fffaeb",
      border: "#FBBC04",
    },
  },
  fontSizes: [12, 14, 16, 18, 24, 32, 36, 72, 96],
  space: [0, 4, 8, 16, 32, 64, 128, 256],

  message: {
    color: "#182353",
  },

  buttons: {
    main: {
      width: "264px",
      height: "50px",
      padding: "6px 12px",
      fontSize: "16px",
      lineHeight: "16px",
      weight: "500",
      color: "#182353",
      background: "#47FE75",
      radius: "100px",
      shadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
      border: "none",

      hover: {
        background: "#18a43b",
        color: "#FFFFFF",
      },
    },

    secondary: {
      width: "264px",
      height: "50px",
      padding: "6px 12px",
      lineHeight: "24px",
      fontSize: "16px",
      weight: "500",
      color: "#182353",
      background: "#FFFFFF",
      border: "#47FE75",
      radius: "100px",
      shadow: "none",

      hover: {
        background: "#18a43b",
        color: "#FFFFFF",
        border: "#18a43b",
      },
    },

    middle: {
      width: "auto",
      height: "auto",
      padding: "10px 20px",
      lineHeight: "24px",
      fontSize: "16px",
      weight: "500",
      color: "#182353",
      background: "#C9FFD6",
      radius: "100px",
      shadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",

      hover: {
        background: "#18a43b",
        color: "#FFFFFF",
      },
    },

    critical: {
      width: "264px",
      height: "50px",
      padding: "6px 12px",
      lineHeight: "24px",
      fontSize: "16px",
      weight: "500",
      color: "#182353",
      background: "#FFFFFF",
      border: "#ff4d4f",
      radius: "100px",
      shadow: "none",

      hover: {
        background: "#ff4d4f",
        color: "#FFFFFF",
        border: "#ff4d4f",
      },
    },

    submit: {
      width: "264px",
      height: "50px",
      padding: "6px 12px",
      fontSize: "16px",
      lineHeight: "24px",
      weight: "500",
      color: "#182353",
      background: "#47FE75",
      radius: "100px",
      shadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
      border: "#47FE75",

      hover: {
        background: "#0A1338",
        color: "#FFFFFF",
        border: "#0A1338",
      },

      focus: {
        background: "#47FE75",
        color: "#182353",
        border: "none",
      },

      disabled: {
        background: "#47FE75",
        color: "#182353",
        border: "#47FE75",
        opacity: "0.3",
      },
    },

    modalButton: {
      width: "auto",
      height: "42px",
      padding: "9px 17px",
      fontSize: "16px",
      lineHeight: "24px",
      weight: "500",
      color: "#182353",
      background: "#47FE75",
      shadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
      border: "0",
      radius: "100px",

      reset: {
        background: "#C9FFD6",
        color: "#182353",
        shadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
        hover: {
          background: "#0A1338",
          color: "#FFFFFF",
        },
      },

      hover: {
        background: "#0A1338",
        color: "#FFFFFF",
      },

      focus: {
        background: "#47FE75",
        color: "#182353",
        border: "none",
      },

      disabled: {
        background: "#47FE75",
        color: "#182353",
        opacity: "0.3",
      },
    },

    startHere: {
      width: "auto",
      height: "auto",
      padding: "6px 12px",
      fontSize: "16px",
      lineHeight: "20px",
      weight: "500",
      background: "transparent",
      border: "#47FE75",
      color: "#47FE75",

      hover: {
        background: "transparent",
        color: "#FFFFFF",
        mainColor: "#182353",
        border: "transparent",
        borderColor: "#182353",
      },
    },

    coupon: {
      height: "50px",
      padding: "6px 12px",
      lineHeight: "24px",
      fontSize: "16px",
      weight: "500",
      color: "#182353",
      background: "#FFFFFF",
      border: "#47FE75",
      radius: "100px",
      shadow: "none",

      hover: {
        background: "#18a43b",
        color: "#FFFFFF",
        border: "#18a43b",
      },
    },

    withIcon: {
      width: "auto",
      height: "auto",
      padding: "8px 12px",
      fontSize: "14px",
      lineHeight: "14px",
      weight: "500",
      color: "#182353",
      background: "#47FE75",
      radius: "100px",
      shadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
      border: "none",

      hover: {
        background: "#18a43b",
        color: "#FFFFFF",
      },
    },
  },
};
